module.exports = __webpack_public_path__ + "img/line.11aa622e.svg";